export const expertsTabs = {
  BROWSE: 'browse',
  MY_EXPERTS: 'myexperts',
};
export const myExpertsGuest = {
  TITLE: 'Where are my experts?',
  SUBTITLE: 'Sign up and start connecting with experts who can help with your school search.',
};
